import { createReducer } from 'store/utils';
import { RootActions } from 'store/types';
import { EntityType } from 'store/entities/types';
import { actionsHandlers, stateFactories } from 'store/entities/utils';
import { Survey } from 'api/general/models';
import * as actions from '../actions';

const stateFactory = stateFactories.createInitialEntitiesStateFactory<EntityType<Survey>>();
const initialState = stateFactory.getInitialState();

type State = typeof initialState;
type Actions = RootActions<typeof actions>;

const surveysReducer = createReducer<State, Actions>(initialState, {
  [actions.getSurveys.request.type]: actionsHandlers.handleGetManyRequest,
  [actions.getSurveys.success.type]: actionsHandlers.handleGetManySuccess,
  [actions.getSurveys.failure.type]: actionsHandlers.handleGetManyFailure,
  [actions.getSurveys.reset.type]: actionsHandlers.handleGetManyReset,
  [actions.updateSurvey.request.type]: actionsHandlers.handleUpdateOneRequest,
  [actions.updateSurvey.success.type]: actionsHandlers.handleUpdateOneSuccess,
  [actions.updateSurvey.failure.type]: actionsHandlers.handleUpdateOneFailure,
  [actions.updateSurvey.reset.type]: actionsHandlers.handleUpdateOneReset,
});

export default surveysReducer;
